import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import DeviceGraph from '../features/DeviceGraph/index.web';

const DeviceGraphWidget = ({ setShowCurrentDevice, selectedGroup, widget }) => {
  const {
    data: connectedDevices = [],
    isLoading: connectedDevicesLoading,
    isError: connectedDevicesError,
  } = useGetConnectedDevicesQuery();

  return (
    <div className="d-flex flex-column h-100 w-100 min-h-0 min-w-0 overflow-hidden">
      {connectedDevices?.length > 0 && (
        <DeviceGraph
          title={null}
          setShowCurrentDevice={setShowCurrentDevice}
          startTime={Date.now() - 24 * 60 * 60 * 1000}
          endTime={Date.now()}
          widget={widget}
          selectedGroup={selectedGroup}
        />
      )}
    </div>
  );
};

export default DeviceGraphWidget;
